import React from "react";
import { Button } from "reactstrap";
import { Topic } from "../Models/Topic";
import { Modal, ModalHeader, ModalFooter, ModalBody } from "../../Layout";
import ElementSpacer from "../../Layout/Components/ElementSpacer";

type Props = {
  topic: Topic;
  toggle: boolean;
  onToggle: () => void;
  onArchive: (topic: Topic) => void;
};

export class ArchiveTopicModal extends React.Component<Props> {
  onToggle = () => {
    this.props.onToggle();
  };

  onArchive = () => {
    this.props.onToggle();
    this.props.onArchive(this.props.topic);
  };

  render() {
    return (
      <Modal width="600px" height="300px" isOpen={this.props.toggle} onToggle={this.onToggle}>
        <ModalHeader toggle={this.onToggle}>Archive Topic</ModalHeader>
        <ModalBody>
          <p>Are you sure you want to archive {this.props.topic.name}?</p>
        </ModalBody>
        <ModalFooter>
          <ElementSpacer>
            <Button color="danger" onClick={this.onArchive}>
              Archive
            </Button>
            <Button onClick={this.onToggle}>Cancel</Button>
          </ElementSpacer>
        </ModalFooter>
      </Modal>
    );
  }
}
